import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { selectIsReadOnly, selectUserRole } from 'store/Faraday/selectors';
import { openModal } from 'store/modals/actions';
import { MODAL_APPLY_TEMPLATE } from 'store/modals/modals';
import Button from 'shared/ui/Button';
import TemplateIcon from './styled';
import ModalWarning from 'Common/Components/ModalWarning';

const ApplyTemplate = ({ hasVulns, vulnsSelected, entity }) => {
  const [showWarning, setShowWarning] = useState(false);
  const dispatch = useDispatch();
  const role = useSelector(selectUserRole);
  const intl = useIntl();
  const readOnly = useSelector(selectIsReadOnly);
  const canUpdate = (entity === 'vulnsGeneral')
    ? (role !== 'client') && (role !== 'asset_owner') && hasVulns
    : !readOnly && (role !== 'client') && (role !== 'asset_owner') && hasVulns;
  const message = intl.formatMessage({ id: 'modalWarning.selectOneOrMore' }, { entity: 'vulnerabilities' });

  const handleClick = () => {
    if (canUpdate) {
      if (vulnsSelected.length > 0) dispatch(openModal(MODAL_APPLY_TEMPLATE));
      else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <Button variant="ghost" startIcon={ <TemplateIcon /> } title="Apply Template" ariaLabel="Apply Template" onClick={ handleClick } disabled={ !canUpdate } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Apply Template" description={ message } /> }
    </>
  );
};

export default ApplyTemplate;
